import React from 'react';
import PropTypes from 'prop-types';

import { List, fromJS } from 'immutable';
import { connect } from 'react-redux';

import {
    getAvailableReturnedBrands,
    omittedBrandsSelector
} from 'ctm-selectors';

const withUnavailableBrands = (Component) => {
    class WithState extends React.PureComponent {

        render() {
            const { unavailableBrands, availableBrandCodes, ...rest } = this.props;
            if (!availableBrandCodes || availableBrandCodes.length === 0) {
                return <Component { ...rest } />;
            }
            return <Component { ...rest } unavailableBrands={unavailableBrands} availableQuotesSize={availableBrandCodes.length} />;
        }

    }

    WithState.propTypes = {
        unavailableBrands: PropTypes.instanceOf(List),
        availableBrandCodes: PropTypes.array
    };

    return connect(mapStateToProps)(WithState);
};

// @See /packages/ctm-components/components/results/comparable_results/comparable_results.js
const mapStateToProps = (state) => {
    const omittedBrands = omittedBrandsSelector(state) || [];

    const availableBrandCodes = getAvailableReturnedBrands(state, true)
        .reduce((acc, quote) => {
            const providerCode = quote.getIn(['providerMeta', 'code']);
            if (!acc.includes(providerCode)) {
                acc.push(providerCode);
            }
            return acc;
        }, []);

    const unavailableBrands = getAvailableReturnedBrands(state, false)
        .filter((quote) => {
            const providerCode = quote.getIn(['providerMeta', 'code']);
            return !availableBrandCodes.includes(providerCode);
        })
        .concat(omittedBrands.map((providerMeta) => fromJS({ providerMeta })))
        .sort(((a, b) => {
            const aCode = a.getIn(['providerMeta', 'code']);
            const bCode = b.getIn(['providerMeta', 'code']);
            if (aCode < bCode) {
                return -1;
            }
            if (aCode > bCode) {
                return 1;
            }
            return 0;
        }));
    return {
        unavailableBrands,
        availableBrandCodes
    };
};

export { withUnavailableBrands };
